import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PolicyService {
  groupId = '';
  groupNumber = '';
  policyNumber = '';
  policyName = '';
  policyNumbers: string[] = [];

  setgroupId(groupId: string): void {
    this.groupId = groupId;
  }

  setgroupNumber(groupNumber: string): void {
    this.groupNumber = groupNumber;
  }

  setpolicyId(policyId: string): void {
    this.policyNumber = policyId;
  }

  setpolicyIds(policyIds: string[]): void {
    this.policyNumbers = policyIds;
  }

  setpolicyName(policyName: string): void {
    this.policyName = policyName;
  }
}
